import React, { Fragment, useState } from "react"
import 'react-image-lightbox/style.css';
import { Button } from "reactstrap";
import iconSub from '../../../assets/images/icon-sub.png';
import profilePic from '../../../assets/images/users/no-img.jpg';
import PriceUtils from "../../../helpers/PriceUtils";


const ProductViewVariant = (props: any) => {
    const { data, dataActive, imgs, setData, type,id,  varriant, attributes, unit, onlyView, } = props

    const RenderItem = ({dataItem, index, indexParent = null, dataStock}:any)=>{
        const [item, setItem] = useState<any>(dataItem);

        const handleAddData = ()=>{
            props?.setDataActive(item)
        }

        const stock_quantity = dataStock?.reduce((prevStock:any, itemStock:any)=>{
            if(item?.unit_value){
                prevStock = prevStock + (Number(itemStock?.quantity || 0) / Number(item?.unit_value || 0))
            }else{
                prevStock = prevStock + Number(itemStock?.quantity || 0)
            }
            
            return prevStock
        },0)

        console.log("dataStock", dataStock, dataItem)

        return (
            <>
                <div key={`${item?.id}-${index}`} className={`item-varriant-detail ${dataActive?.sku === item?.sku ? 'active':''}`} onClick={handleAddData}>
                    {indexParent !== null &&
                        <img className="varriant-icon-unit"  src={iconSub} style={{width: 20, height: 20, maxWidth: 'unset', maxHeight: 'unset', border: 'none', margin: 10}}/>
                    }
                    <label className="tee-file-preview" htmlFor="avatar" style={{width: 45, height: 45, marginRight: 10}}>
                        <img  src={data.avatar || imgs[0]?.url || profilePic} style={{maxWidth: 'unset', maxHeight: 'unset'}}/>
                    </label>
                    <span style={{flex:1, display:'flex', flexDirection:'column'}}>
                        <span style={{flex:1}}>{item?.name}</span>
                        <span style={{flex:1, display: 'flex',}}>
                            <span style={{marginRight:10}}><b>Tồn kho: {PriceUtils.format(stock_quantity, '')}</b></span>
                            <span><b>Có thể bán: {PriceUtils.format(stock_quantity, '')}</b></span>
                        </span>
                    </span>
                    
                </div>
                {item?.units?.map((itemUnit:any, indexUnit:number)=>{
                    return <RenderItem dataItem={itemUnit} indexParent={index} index={indexUnit} dataStock={dataStock}/>
                })}
            </>
        )
    }
    
    const attributeCount = attributes?.reduce((prev:any, item:any)=>{
        if(item?.properties?.length > 0) prev = prev + 1
        return prev
    },0)

    const unitCount = unit?.reduce((prev:any, item:any)=>{
        if(item?.name && item?.quantity_conversion) prev = prev + 1
        return prev
    },0) 

    const totalVarriant = attributeCount === 0 ? unitCount : (varriant?.length === 1 && unitCount == 1) ? 2 : (varriant?.length * (unitCount + 1))

    return (
        <div className="card">
            <div className="card-body p-0 pb-4">
                <div className="nutri-title mb-3" style={{padding: '1.25rem', paddingBottom: 0}}>Phiên bản ({totalVarriant})</div>
                <div>
                    {varriant && varriant?.length > 0 ? varriant?.map((item: any, index: number) => (
                        <RenderItem dataItem={item} index={index} dataStock={item?.product_stock} />
                    )):
                    <RenderItem dataItem={data} index={0} dataStock={data?.product_stock} />
                }
                </div>
                {type !=='view' && id !== 'add' &&
                <div className='select-menu-add' style={{border: 'none'}} onClick={() => props?.handleActionModal({type: 'attributesModal'})}>
                    <i className="uil-plus mr-1"></i> Thêm / sửa phiên bản
                </div>
                }
            </div>
        </div>
    )
}

export default ProductViewVariant